module.exports = __webpack_public_path__ + "static/img/TOP_Backgrand_1200-800.9dfdc01.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/TOP_Backgrand_1200-800.png
// module id = fsj4
// module chunks = 1